import React, { ButtonHTMLAttributes, FC, useEffect, useState } from 'react';

import Icon from '../../../assets/icons';

import { StyledPauseButton } from './styles';

export interface IButtonPauseProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isActive?: boolean;
}

const ButtonPause: FC<IButtonPauseProps> = ({ isActive, ...props }) => {
  const [active, setActive] = useState(false);

  // const handleClick: MouseEventHandler<HTMLButtonElement> = useCallback(
  //   (e) => {
  //     setActive((prev) => !prev);
  //     onClick && onClick(e);
  //   },
  //   [onClick],
  // );

  useEffect(() => {
    setActive(isActive || false);
  }, [isActive]);

  return (
    <StyledPauseButton {...props}>
      {active ? <Icon variant="start" /> : <Icon variant="pause" />}
    </StyledPauseButton>
  );
};

export default ButtonPause;
